// extracted by mini-css-extract-plugin
module.exports = {"checkboxColumn":"styles_checkboxColumn__3L7kl","title":"styles_title__2dmCH","checkboxWrapper":"styles_checkboxWrapper__3xBeL"};